import React from 'react';
import { List } from '../List/List';

interface KeyValueRenderConfig {
	label: {
		textSecondary: boolean;
	};
}

type KeyValueItem = {
	label: string;
	value?: string;
};

interface KeyValueProps extends KeyValueItem {
	config?: KeyValueRenderConfig;
}

interface KeyValuePropsList {
	options: KeyValueItem[];
	config?: KeyValueRenderConfig;
}

export const KeyValue = ({ label, value, config }: KeyValueProps) => (
	<React.Fragment key={`key-value-${label}-${value}`}>
		<span
			className={
				config?.label.textSecondary
					? 'text-(--text-secondary)'
					: 'text-(--text-tertiary)'
			}>
			{label}
		</span>
		&nbsp;
		<strong>{value}</strong>
	</React.Fragment>
);
export const KeyValues = ({ options, config }: KeyValuePropsList) => (
	<List
		data={options.map((option) => (
			<KeyValue
				key={`${option.label}-${option.value}`}
				{...option}
				config={config}
			/>
		))}
	/>
);
